import React, { ComponentProps } from 'react';
import classNames from 'classnames';
import { Section } from '@fiverr-private/layout_components';
import { sectionClass, sectionPaddingYClass } from '../../styles/section.ve.css';

type PageSectionProps = Omit<ComponentProps<typeof Section>, 'fullWidth' | 'equalPadding'>;

/**
 * A page section: 1440px max width, 60px side paddings (32px below 1440px) and 60px vertical paddings.
 * Passing `paddingTop` or `paddingBottom` replaces the default vertical paddings.
 */
const PageSection = ({ className, paddingTop, paddingBottom, ...restProps }: PageSectionProps) => {
    const hasCustomPaddingY = paddingTop !== undefined || paddingBottom !== undefined;

    return (
        <Section
            {...restProps}
            fullWidth
            className={classNames(sectionClass, !hasCustomPaddingY && sectionPaddingYClass, className)}
            paddingTop={paddingTop}
            paddingBottom={paddingBottom}
        />
    );
};

export default PageSection;
